
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Hourglass } from "react-loader-spinner";
import { FaHeart, FaComment, FaCamera, FaImage, FaCirclePlus, FaTrash, FaReply, FaThumbsUp } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import CreatePostNew from "../../../components/create-post-new";
import TimestampConverter from "../../../components/TimestampConverter";
import bg3 from "../../../assets/images/page-img/profile-bg3.jpg";
import {
  addMediaToStories,
  deletePostComment,
  FBProfile,
  getFbstories,
  getPostComments,
  insertPostComment,
} from "../../../store/facebook/facebookThunk";
import { uploadFileToCloudinary } from "../../../store/Cloudinary/CloudinaryThunk";
import user1 from "../../../assets/images/user/users.png";
import { FaEllipsisH } from "react-icons/fa";

// Remove all FsLightbox/imageController/Showimg state and logic

const FacebookProfile = () => {
  const dispatch = useDispatch();
  const {
    profile,
    loading: Fbloading,
    Comments,
    fbstoriessccsess,
  } = useSelector((state) => state.facebook);
  const { uploadedFile, uploading } = useSelector((state) => state.cloudinary);

  console.log(Comments, 'CommentsCommentsCommentsCommentsComments')
  // State management
  const [showComments, setShowComments] = useState({});
  const [Fbstories, setFbstories] = useState(null);
  const [Showimg, setShowimg] = useState(null);
  const [showStoryModal, setShowStoryModal] = useState(false);
  const [localComments, setLocalComments] = useState({});
  const [storyLightbox, setStoryLightbox] = useState({
    toggler: false,
    slide: 1,
    sources: [],
  });
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [apiLoading, setApiLoading] = useState({
    comments: {},
    posting: false,
    deleting: {},
  });

  // Validation schemas
  const commentValidationSchema = useMemo(
    () =>
      Yup.object({
        commentText: Yup.string()
          .trim()
          .required("Comment is required")
          .min(1, "Comment cannot be empty")
          .max(500, "Comment cannot exceed 500 characters"),
      }),
    []
  );

  const storyValidationSchema = useMemo(
    () =>
      Yup.object({
        file: Yup.mixed().required("File is required"),
      }),
    []
  );
  const toggleComments = useCallback(
    (postId) => {
      setShowComments((prevState) => {
        const isVisible = !prevState[postId];

        if (isVisible && !localComments[postId]) {
          // Start loading
          setApiLoading((prev) => ({
            ...prev,
            comments: { ...prev.comments, [postId]: true },
          }));

          dispatch(getPostComments(postId))
            .unwrap()
            .then((response) => {
              const fetchedComments = response?.comments?.data || [];

              // ✅ Only set local comments if response has expected structure
              if (Array.isArray(fetchedComments)) {
                setLocalComments((prev) => ({
                  ...prev,
                  [postId]: fetchedComments,
                }));
              } else {
                // Handle unexpected response structure
                toast.error("Failed to fetch comments: Invalid data format");
              }
            })
            .catch((err) => {
              // ✅ Catch and show error message
              const message =
                err?.message || err?.error?.message || "Server error occurred";
              toast.error(`Error fetching comments: ${message}`);
            })
            .finally(() => {
              // End loading
              setApiLoading((prev) => ({
                ...prev,
                comments: { ...prev.comments, [postId]: false },
              }));
            });
        }

        return {
          ...prevState,
          [postId]: isVisible,
        };
      });
    },
    [dispatch, localComments]
  );

  // Handle lightbox image display
const imageOnSlide = useCallback(
  (number, item, albumImages = null) => {
    if (albumImages && Array.isArray(albumImages)) {
      const sources = albumImages
        .map((sub, index) => ({
          src: sub?.media?.image?.src,
          type: 'image',
          caption: `Image ${index + 1} of ${albumImages.length}`
        }))
        .filter(img => img.src);
      
      if (sources.length === 0) {
        toast.error("No valid images found in album");
        return;
      }
      
      Fancybox.show(sources, { 
        startIndex: number || 0,
        groupAll: true 
      });
    } else if (typeof item === 'string' && item) {
      Fancybox.show([{
        src: item,
        type: 'image',
        caption: 'Facebook Photo'
      }]);
    } else {
      toast.error("Cannot open image: Invalid URL");
    }
  },
  []
);

  // Handle story lightbox
  const openStoryLightbox = useCallback(
    (stories, index = 0) => {
      const sources = stories.map((story) => {
        if (story.type === "video") {
          // For videos, we'll show the thumbnail in lightbox since fslightbox handles videos differently
          return story.src; // or story.thumbnail if you prefer
        }
        return story.src;
      });
      setStoryLightbox({
        toggler: !storyLightbox.toggler,
        slide: index + 1,
        sources,
      });
    },
    [storyLightbox.toggler]
  );

  // Handle showing story modal
  const handleShowStory = useCallback(() => {
    setShowStoryModal(true);
  }, []);

  // Handle modal close
  const handleCloseStoryModal = useCallback(() => {
    setShowStoryModal(false);
  }, []);

  // Handle adding a comment
  // Handle adding a comment
  const handleAddComment = useCallback(
    async (postId, text, resetForm) => {
      if (!text.trim() || !postId) return;

      setApiLoading((prev) => ({ ...prev, posting: true }));

      try {
        const data = { postId, message: text.trim() };
        const result = await dispatch(insertPostComment(data)).unwrap();

        if (result.status === 200) {
          // Create new comment object with server-provided ID
          const newComment = {
            id: result.id, // Use the actual ID from the server response
            message: text.trim(),
            created_time: new Date().toISOString(),
            from: {
              id: profile?.data?.id,
              name: profile?.data?.name,
              picture: {
                data: {
                  url: profile?.data?.picture?.data?.url
                }
              }
            }
          };

          // Add to local comments state immediately
          setLocalComments(prev => ({
            ...prev,
            [postId]: [...(prev[postId] || []), newComment]
          }));

          toast.success("Comment added successfully!");
          resetForm();
        } else {
          toast.error(result.message || "Failed to add comment.");
        }
      } catch (error) {
        console.error("Error posting comment:", error);
        toast.error("Failed to add comment. Please try again.");
      } finally {
        setApiLoading((prev) => ({ ...prev, posting: false }));
      }
    },
    [dispatch, profile]
  );



  const handleDeleteComment = useCallback(
    async (postId, commentId) => {
      if (!commentId || !postId) return;

      const confirmDelete = window.confirm("Are you sure you want to delete this comment?");
      if (!confirmDelete) return;

      setApiLoading((prev) => ({
        ...prev,
        deleting: { ...prev.deleting, [commentId]: true },
      }));

      try {
        await dispatch(deletePostComment({ postId, commentId })).unwrap();

        // Remove from local comments state immediately after success
        setLocalComments(prev => ({
          ...prev,
          [postId]: (prev[postId] || []).filter(comment => comment.id !== commentId)
        }));

        toast.success("Comment deleted successfully!");
      } catch (error) {
        console.error("Error deleting comment:", error);
        toast.error("Failed to delete comment. Please try again.");
      } finally {
        setApiLoading((prev) => ({
          ...prev,
          deleting: { ...prev.deleting, [commentId]: false },
        }));
      }
    },
    [dispatch]
  );


  // Handle story submission
  const submitStoryForm = useCallback(
    async (values, { setSubmitting, resetForm }) => {
      if (!values.file) {
        toast.error("Please select a file");
        return;
      }

      setSubmitting(true);
      try {
        toast.info("Uploading your story...");
        const uploadResult = await dispatch(uploadFileToCloudinary(values.file)).unwrap();
        if (uploadResult?.url) {
          const storyData = {
            imageUrl: uploadResult.url,
            media_type: values.file.type.startsWith("video/") ? "VIDEO" : "STORIES",
          };
          await dispatch(addMediaToStories(storyData)).unwrap();
          toast.success("Story uploaded successfully!");
          resetForm();
          setShowStoryModal(false);
          await dispatch(getFbstories()).unwrap();
        } else {
          toast.error("Failed to upload file. Please try again.");
        }
      } catch (error) {
        console.error("Story upload error:", error);
        toast.error("Something went wrong while uploading the story.");
      } finally {
        setSubmitting(false);
      }
    },
    [dispatch]
  );

  // Custom Stories Component
  const CustomStories = ({ stories, userImage, userName, onAddStory }) => {
    console.log(stories, "storiesstoriesstoriesstories")
    return (
      <div className="flex space-x-3 overflow-x-auto pb-2">
        {/* Add Story Button */}
        <div className="flex-shrink-0">
          <div onClick={() => {
            // Check if user has stories, if yes show them, otherwise open modal
            if (stories && stories.length > 0) {
              openStoryLightbox([{
                id: 'user-story',
                type: 'photo',
                src: userImage || user1,
                thumbnail: userImage || user1
              }], 0);
            } else {
              onAddStory();
            }
          }} className="relative cursor-pointer group">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-red-500 p-0.5">
              <div className="w-full h-full rounded-full bg-white p-0.5">
                <img
                  src={userImage || user1}
                  className="w-full h-full rounded-full object-cover"
                  alt="Add Story"
                />
              </div>
            </div>
            <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-[#50B5FF] rounded-full flex items-center justify-center border-2 border-white">
              <FaCamera className="w-3 h-3 text-white" />
            </div>
          </div>
          {/* <p className="text-xs text-center mt-2 text-gray-600 font-medium">Add Story</p> */}
        </div>

        {/* Existing Stories */}
        {stories &&
          stories.length > 0 &&
          stories.map((story, index) => (
            <div key={story.id || index} className="flex-shrink-0">
              <div onClick={() => openStoryLightbox(stories, index)} className="relative cursor-pointer group">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-red-500 p-0.5">
                  <div className="w-full h-full rounded-full bg-white p-0.5">
                    {/* <div className="relative w-full h-full rounded-full overflow-hidden">
                      <img
                        src={story.thumbnail || story.src}
                        className="w-full h-full object-cover"
                        alt="Story"
                      />
                    </div> */}
                    <div className="relative w-full h-full rounded-full overflow-hidden">
                      {story.type === "video" ? (
                        <div className="relative w-full h-full">
                          <h1>video</h1>
                          <img
                            src={story.thumbnail || story.src}
                            className="w-full h-full object-cover"
                            alt="Video Story"
                          />
                          <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-6 h-6 bg-white bg-opacity-80 rounded-full flex items-center justify-center">
                              <div className="w-0 h-0 border-l-[6px] border-l-gray-800 border-t-[3px] border-t-transparent border-b-[3px] border-b-transparent ml-0.5"></div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <img
                          src={story.thumbnail || story.src}
                          className="w-full h-full object-cover"
                          alt="Photo Story"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-xs text-center mt-2 text-gray-600 font-medium truncate">
                {story.type === "video" ? "Video" : "Photo"}
              </p>
            </div>
          ))}
      </div>
    );
  };

  // Facebook Banner Component
  const FacebookBanner = ({ coverImage, profileImage, name, isOnline = true }) => {
    return (
      <div className="relative bg-white rounded-2xl shadow-md border overflow-hidden mb-6">
        <div className="relative h-64 md:h-80 bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600">
          {coverImage ? (
            <img src={coverImage} alt="Cover" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 flex items-center justify-center">
              <div className="text-white text-center">
                <FaImage className="w-12 h-12 mx-auto mb-2 opacity-50" />
                <p className="text-sm opacity-70">Add Cover Photo</p>
              </div>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
          {/* <button className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm text-gray-700 px-4 py-2 rounded-lg text-sm font-medium hover:bg-white transition-all duration-200 flex items-center space-x-2">
            <FaCamera className="w-4 h-4" />
            <span>Edit Cover</span>
          </button> */}
        </div>
        <div className="relative px-6 pb-6">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between -mt-16 md:-mt-20">
            <div className="relative">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-white p-1 shadow-lg">
                <img
                  src={profileImage || user1}
                  alt={name}
                  className="w-full h-full rounded-full object-cover"
                />
              </div>
              {isOnline && (
                <div className="absolute bottom-2 right-2 w-8 h-8 bg-green-500 rounded-full border-4 border-white"></div>
              )}
              {/* <button className="absolute bottom-0 right-8 w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center border-2 border-white hover:bg-gray-200 transition-colors">
                <FaCamera className="w-4 h-4 text-gray-600" />
              </button> */}
            </div>
            {/* <div className="flex space-x-2 mt-4 md:mt-0 md:mb-4">
              <button
                onClick={handleShowStory}
                className="flex-1 md:flex-none bg-[#50B5FF] text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-600 transition-colors flex items-center justify-center space-x-2"
              >
                <FaCamera className="w-4 h-4" />
                <span>Add Story</span>
              </button>
              <button className="flex-1 md:flex-none bg-gray-100 text-gray-700 px-6 py-2 rounded-lg font-medium hover:bg-gray-200 transition-colors">
                Edit Profile
              </button>
            </div> */}
          </div>
          <div className="mt-4">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">{name}</h1>
            <p className="text-gray-600 mt-1">{profile?.data?.followers_count || 0} followers</p>
            {profile?.data?.about && (
              <p className="text-gray-700 mt-2 text-sm md:text-base leading-relaxed">
                {profile.data.about.split("\n")[0]}
              </p>
            )}
          </div>
          {/* <div className="flex space-x-8 mt-6 border-t border-gray-200 pt-4">
            <button className="text-[#50B5FF] font-medium border-b-2 border-[#50B5FF] pb-2">Posts</button>
            <button className="text-gray-600 hover:text-gray-900 font-medium pb-2">About</button>
            <button className="text-gray-600 hover:text-gray-900 font-medium pb-2">Friends</button>
            <button className="text-gray-600 hover:text-gray-900 font-medium pb-2">Photos</button>
            <button className="text-gray-600 hover:text-gray-900 font-medium pb-2">Videos</button>
          </div> */}
        </div>
      </div>
    );
  };

  // Initial data fetch
  useEffect(() => {
    if (isInitialLoad) {
      const loadInitialData = async () => {
        try {
          await Promise.all([dispatch(FBProfile()).unwrap(), dispatch(getFbstories()).unwrap()]);
        } catch (error) {
          console.error("Error loading initial data:", error);
        } finally {
          setIsInitialLoad(false);
        }
      };
      loadInitialData();
    }
  }, [dispatch, isInitialLoad]);

  // Process Facebook stories
  useEffect(() => {
    if (fbstoriessccsess) {
      const formattedStories = fbstoriessccsess.map((item) => ({
        id: item?.media_id,
        type: item?.media_type === "VIDEO" ? "video" : "photo",
        src: item?.media_type === "VIDEO" ? item?.source : item?.picture,
        thumbnail: item?.picture,
        isVideo: item?.media_type === "VIDEO"
      }));
      setFbstories(formattedStories);
    }
  }, [fbstoriessccsess]);

  // Add profile-2 class to body
  useEffect(() => {
    document.body.classList.add("profile-2");
    return () => document.body.classList.remove("profile-2");
  }, []);

  useEffect(() => {
    // Clean up any existing instances
    try {
      Fancybox.destroy();
    } catch (e) {
      console.log("Fancybox cleanup:", e);
    }

    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      try {
        Fancybox.bind("[data-fancybox]", {
          Thumbs: {
            autoStart: false
          },
          Toolbar: {
            display: [
              { id: "counter", position: "left" },
              "zoomIn",
              "zoomOut",
              "fullscreen",
              "download",
              "close"
            ]
          }
        });
      } catch (e) {
        console.error("Fancybox init error:", e);
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      try {
        Fancybox.destroy();
      } catch (e) {
        console.log("Fancybox cleanup on unmount:", e);
      }
    };
  }, []);



  // Loading state
  // if (Fbloading || isInitialLoad) {
  //   return (
  //     <div className="flex justify-center items-center h-screen bg-gray-50">
  //       <Hourglass
  //         visible={true}
  //         height="40"
  //         width="40"
  //         ariaLabel="hourglass-loading"
  //         colors={["#50B5FF", "#50B5FF"]}
  //       />
  //     </div>
  //   );
  // }

  // Error state
  if (profile?.error) {
    return (
      <div className="flex justify-center items-center h-[50vh] bg-gray-50">
        <div className="text-center p-6 bg-white rounded-xl shadow-md">
          <h4 className="text-xl font-semibold text-gray-800 mb-2">Error loading profile</h4>
          <p className="text-gray-600 mb-4">{profile.error}</p>
          <Button
            onClick={() => window.location.reload()}
            className="bg-[#50B5FF] text-white px-6 py-2 rounded-full hover:bg-blue-600 transition-all duration-200"
          >
            Retry
          </Button>
        </div>
      </div>
    );
  }

  const CommentItem = ({ comment, postId, onDelete }) => {
    const isOwnComment = comment?.from?.id === profile?.data?.id;
    const [showActions, setShowActions] = useState(false);
    const isDeleting = apiLoading.deleting[comment.id];

    return (
      <div
        className={`bg-white rounded-xl p-4 mb-3 border border-gray-100 hover:shadow-sm transition-all duration-200 ${isDeleting ? 'opacity-50' : ''}`}
        onMouseEnter={() => setShowActions(true)}
        onMouseLeave={() => setShowActions(false)}
      >
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <img
              src={comment?.from?.picture?.data?.url || user1}
              alt={comment?.from?.name || "User"}
              className="w-10 h-10 rounded-full object-cover border-2 border-gray-100"
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="bg-gray-50 rounded-2xl px-4 py-3 relative">
              <div className="flex items-center justify-between mb-1">
                <h5 className="font-semibold text-gray-900 text-sm">
                  {comment?.from?.name || "Unknown User"}
                </h5>
                {showActions && (
                  <button
                    onClick={() => onDelete(postId, comment.id)}
                    disabled={isDeleting}
                    className="text-gray-400 hover:text-red-500 transition-colors p-1 rounded-full hover:bg-red-50 disabled:cursor-not-allowed"
                    title="Delete comment"
                  >
                    {isDeleting ? (
                      <div className="w-3 h-3 border-2 border-red-500 border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <FaTrash className="w-3 h-3" />
                    )}
                  </button>
                )}
              </div>
              <p className="text-gray-800 text-sm leading-relaxed break-words">
                {comment?.message || "No message"}
              </p>
            </div>
            <div className="flex items-center space-x-4 mt-2 px-2">
              <button className="text-xs text-gray-500 hover:text-blue-600 font-medium transition-colors flex items-center space-x-1">
                <FaThumbsUp className="w-3 h-3" />
                <span>Like</span>
              </button>
              <div className="text-xs text-gray-400">
                <TimestampConverter timestamp={comment?.created_time} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  // Enhanced Comments Section Component
  const CommentsSection = ({ postId, isLoading }) => {
    const comments = localComments[postId] || [];

    if (isLoading) {
      return (
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex justify-center items-center py-4">
            <span className="ml-2 text-gray-500 text-sm">Loading comments...</span>
          </div>
        </div>
      );
    }

    if (!comments || comments.length === 0) {
      return (
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="text-center py-4">
            <FaComment className="w-8 h-8 text-gray-300 mx-auto mb-2" />
            <p className="text-gray-500 text-sm">No comments yet. Be the first to comment!</p>
          </div>
        </div>
      );
    }

    return (
      <div className="space-y-2">
        <div className="flex items-center justify-between mb-4">
          <h6 className="font-semibold text-gray-700 text-sm">
            Comments ({comments.length})
          </h6>
        </div>
        {comments.map((comment, index) => (
          <CommentItem
            key={comment.id || index}
            comment={comment}
            postId={postId}
            onDelete={handleDeleteComment}
          />
        ))}
      </div>
    );
  };

  // Enhanced Comment Form Component
  const CommentForm = ({ postId }) => {
    return (
      <div className="border-t border-gray-100 pt-4 mt-4">
        <Formik
          initialValues={{ commentText: "" }}
          validationSchema={commentValidationSchema}
          onSubmit={(values, { resetForm }) => {
            handleAddComment(postId, values.commentText, resetForm);
          }}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <div className="flex items-start space-x-3">
                <img
                  src={profile?.data?.picture?.data?.url || user1}
                  alt="Your profile"
                  className="w-10 h-10 rounded-full object-cover border-2 border-gray-100"
                />
                <div className="flex-1">
                  <Field
                    as="textarea"
                    name="commentText"
                    rows="2"
                    className="w-full p-3 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent resize-none text-sm placeholder-gray-500"
                    placeholder="Write a comment..."
                  />
                  <ErrorMessage
                    name="commentText"
                    component="div"
                    className="text-red-500 text-xs mt-1 ml-1"
                  />
                  <div className="flex items-center justify-between mt-2">
                    <div className="text-xs text-gray-400">
                      {values.commentText.length}/500
                    </div>
                    <button
                      type="submit"
                      disabled={apiLoading.posting || isSubmitting || !values.commentText.trim()}
                      className="bg-blue-500 hover:bg-blue-600 disabled:bg-gray-300 text-white px-4 py-2 rounded-full text-xs font-medium transition-colors disabled:cursor-not-allowed"
                    >
                      {apiLoading.posting || isSubmitting ? (
                        <div className="flex items-center space-x-1">
                          <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          <span>Posting...</span>
                        </div>
                      ) : (
                        "Post"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  };

  // PostItem component
  const PostItem = ({
    item,
    index,
    profile,
    showComments,
    toggleComments,
    imageOnSlide,
  }) => {
    const postType = item?.attachments?.data?.[0]?.type;
    const isCommentsLoading = apiLoading.comments[item?.id];
    const postComments = localComments[item?.id] || [];

    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 mb-6 overflow-hidden">
        <div className="p-6">
          {/* Post content remains the same */}
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-start space-x-3">
              <img
                src={profile?.data?.picture?.data?.url || user1}
                alt="Profile"
                className="w-12 h-12 rounded-full object-cover border-2 border-gray-100"
              />
              <div>
                <h4 className="font-semibold text-gray-900">{profile?.data?.name}</h4>
                <div className="flex items-center text-gray-500 text-sm">
                  <TimestampConverter timestamp={item?.updated_time || item?.timestamp} />
                </div>
              </div>
            </div>
            <button className="p-2 rounded-full hover:bg-gray-100 transition-colors">
              <FaEllipsisH className="w-5 h-5 text-gray-400" />
            </button>
          </div>

          {/* Post content, images, videos etc. remain the same */}

          {/* Post Content */}
          {item?.message && (
            <div className="px-4 py-3">
              <p className="text-gray-800 text-sm leading-relaxed">{item.message}</p>
            </div>
          )}

          {/* Post Media */}
          {postType === "photo" && (
            <div className="relative">
              <img
                loading="lazy"
                src={item?.attachments?.data[0]?.media?.image?.src}
                alt="post"
                className="w-full max-h-96 object-cover hover:opacity-95 transition-opacity duration-200 cursor-pointer"
                data-fancybox={`post-${item?.id}`}
                data-src={item?.attachments?.data[0]?.media?.image?.src}
                data-caption={item?.message || "Facebook Photo"}
                onClick={(e) => {
                  e.preventDefault();
                  Fancybox.show([{
                    src: item?.attachments?.data[0]?.media?.image?.src,
                    type: 'image',
                    caption: item?.message || "Facebook Photo"
                  }]);
                }}
              />
            </div>
          )}



          {postType === "album" && (
            <div className="grid grid-cols-2 gap-1">
              {item?.attachments?.data[0]?.subattachments?.data?.slice(0, 4).map((subItem, subIndex) => (
                <div
                  key={`album-item-${subIndex}`}
                  className="relative aspect-square overflow-hidden cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    const albumImages = item?.attachments?.data[0]?.subattachments?.data?.map(img => ({
                      src: img?.media?.image?.src,
                      type: 'image',
                      caption: item?.message || `Album Image ${subIndex + 1}`
                    }));
                    Fancybox.show(albumImages, { startIndex: subIndex });
                  }}
                >
                  <img
                    loading="lazy"
                    src={subItem?.media?.image?.src}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    alt="album item"
                  />
                  {subIndex === 3 && item?.attachments?.data[0]?.subattachments?.data?.length > 4 && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                      <span className="text-white font-bold text-lg">
                        +{item.attachments.data[0].subattachments.data.length - 4}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}


          {postType === "video" && (
            <div className="relative aspect-video bg-black">
              <iframe
                title={`video-post-${index}`}
                className="w-full h-full"
                src={item?.source}
                allowFullScreen
              />
            </div>
          )}
          <hr className="my-4 border-gray-100" />
          <div className="flex items-center justify-between mb-4">
            <div className="flex space-x-6">
              <button className="flex items-center space-x-2 text-gray-600 hover:text-red-500 transition-colors">
                <FaHeart className="w-5 h-5" />
                <span className="font-medium">Like</span>
              </button>
              <button
                className="flex items-center space-x-2 text-gray-600 hover:text-blue-500 transition-colors"
                onClick={() => toggleComments(item?.id)}
              >
                <FaComment className="w-5 h-5" />
                <span className="font-medium">
                  Comment {postComments.length > 0 && `(${postComments.length})`}
                </span>
              </button>
            </div>
          </div>

          {showComments[item?.id] && (
            <div className="border-t border-gray-100 pt-4">
              <CommentsSection
                postId={item?.id}
                isLoading={isCommentsLoading}
              />
              <CommentForm postId={item?.id} />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <div id="content-page" className="pt-0 px-4 md:px-6 lg:px-8 max-w-6xl mx-auto">
          <FacebookBanner
            coverImage={profile?.data?.cover?.source || bg3}
            profileImage={profile?.data?.picture?.data?.url}
            name={profile?.data?.name}
            isOnline={true}
          />
          <Row>
            <Col lg="4">
              <Card className="bg-white rounded-2xl shadow-md border mb-6">
                <div className="p-4 border-b border-gray-100">
                  <h4 className="text-lg font-semibold text-gray-900">Stories</h4>
                </div>
                <div className="p-4">
                  <CustomStories
                    stories={Fbstories}
                    userImage={profile?.data?.picture?.data?.url}
                    userName={profile?.data?.name}
                    onAddStory={handleShowStory}
                  />
                </div>
              </Card>
              <Card className="bg-white rounded-2xl shadow-md border mb-6">
                <div className="p-4 border-b border-gray-100 flex justify-between items-center">
                  <h4 className="text-lg font-semibold text-gray-900">About</h4>
                  <Link to="#" className="text-[#50B5FF] text-sm hover:underline">
                    Know More
                  </Link>
                </div>
                <div className="p-4">
                  <div className="flex flex-col space-y-2">
                    {profile?.data?.about ? (
                      profile.data.about.split("\n").map((item, index) => (
                        <p key={index} className="text-gray-700 text-sm">{item}</p>
                      ))
                    ) : (
                      <p className="text-gray-500 text-sm">No bio available</p>
                    )}
                  </div>
                </div>
              </Card>
              <Card className="bg-white rounded-2xl shadow-md border mb-6">
                <div className="p-4 border-b border-gray-100 flex justify-between items-center">
                  <h4 className="text-lg font-semibold text-gray-900">Photos</h4>
                  <Link to="#" className="text-[#50B5FF] text-sm hover:underline">
                    See all
                  </Link>
                </div>
                <div className="p-4">
                  <div className="grid grid-cols-3 gap-2">
                    {profile?.data?.posts?.data
                      ?.filter((item) => item?.attachments?.data?.[0]?.type === "photo")
                      ?.slice(0, 6)
                      ?.map((item, index) => (
                        <div
                          key={item?.id || index}
                          className="relative aspect-square overflow-hidden cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            Fancybox.show([{
                              src: item?.attachments?.data[0]?.media?.image?.src,
                              type: 'image',
                              caption: item?.message || "Facebook Photo"
                            }]);
                          }}
                        >
                          <img
                            loading="lazy"
                            src={item?.attachments?.data[0]?.media?.image?.src}
                            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                            alt="photo"
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </Card>
              {profile?.data?.videos?.data?.length > 0 && (
                <Card className="bg-white rounded-2xl shadow-md border mb-6">
                  <div className="p-4 border-b border-gray-100 flex justify-between items-center">
                    <h4 className="text-lg font-semibold text-gray-900">Videos</h4>
                    <Link to="#" className="text-[#50B5FF] text-sm hover:underline">
                      See all videos
                    </Link>
                  </div>
                  <div className="p-4">
                    <div className="grid gap-4">
                      {profile?.data?.videos?.data
                        ?.filter((item) => !item?.media_type || item?.media_type !== "STORIES")
                        ?.map((item, index) => (
                          <div key={item?.id || index} className="aspect-video rounded-lg overflow-hidden">
                            <iframe
                              title={`video-${index}`}
                              className="w-full h-full"
                              src={item?.source}
                              allowFullScreen
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </Card>
              )}
            </Col>
            <Col lg="8">
              <CreatePostNew
                type="facebook"
                userImage={profile?.data?.picture?.data?.url}
                handleshowStory={handleShowStory}
                className="bg-white rounded-2xl shadow-md border p-4 mb-6"
              />
              {profile?.data?.posts?.data?.map((item, index) => (
                <PostItem
                  key={item.id}
                  item={item}
                  index={index}
                  profile={profile}
                  commentItem={Comments?.find((commenti) => commenti?.postId === item?.id)}
                  showComments={showComments}
                  toggleComments={toggleComments}
                  imageOnSlide={imageOnSlide}
                />
              ))}
            </Col>
          </Row>
        </div>
        {/* <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${showStoryModal ? 'block' : 'hidden'}`}>
          <div className="bg-white rounded-lg max-w-lg w-full mx-4">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h3 className="text-lg font-semibold">Create Story</h3>
              <button onClick={handleCloseStoryModal} className="text-gray-500 hover:text-gray-700">
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            <div className="p-4">
              <div className="flex items-start">
                <img
                  src={profile?.data?.picture?.data?.url || user1}
                  alt="Profile"
                  className="w-12 h-12 rounded-full mr-3"
                />
                <Formik
                  initialValues={{ file: null }}
                  validationSchema={storyValidationSchema}
                  onSubmit={submitStoryForm}
                >
                  {({ setFieldValue, isSubmitting }) => (
                    <Form className="flex-1">
                      <div className="mb-4">
                        <h6 className="font-medium mb-2">Photo/Video Post</h6>
                        <input
                          type="file"
                          name="file"
                          className="w-full border border-gray-300 rounded-lg p-2"
                          accept="image/*,video/*"
                          onChange={(event) => setFieldValue("file", event.currentTarget.files[0])}
                        />
                        <ErrorMessage
                          name="file"
                          component="div"
                          className="text-red-500 text-sm mt-1"
                        />
                      </div>
                      <div className="flex gap-2">
                        <button
                          type="button"
                          onClick={handleCloseStoryModal}
                          className="flex-1 border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-2 px-4 rounded-lg transition"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          disabled={isSubmitting || uploading}
                          className="flex-1 bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white font-medium py-2 px-4 rounded-lg transition"
                        >
                          {isSubmitting || uploading ? "Uploading..." : "Post"}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default FacebookProfile;
